import { OrganizationDTOV2 } from 'src/api/generated'

const MIN_ORGANIZATIONS = 1

const verifyOneOrganization = (
  organizationsByUser: OrganizationDTOV2[] = [],
) => {
  if (organizationsByUser.length > MIN_ORGANIZATIONS) {
    return false
  }

  const [organization] = organizationsByUser
  const { memberships, id: organizationID } = organization
  const [membership] = memberships!
  const { id } = membership

  return {
    organizationID,
    membershipID: id,
  }
}

export default verifyOneOrganization
